var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group form-group--group" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { class: `col-sm-${_vm.component.size}` }, [
        _c("div", { staticClass: "panel panel-default" }, [
          !_vm.component.hideLabel || _vm.component.description
            ? _c("div", { staticClass: "panel-heading" }, [
                !_vm.component.hideLabel
                  ? _c("h4", { staticClass: "panel-title" }, [
                      _vm._v(_vm._s(_vm.component.label)),
                    ])
                  : _vm._e(),
                _vm.component.description
                  ? _c("span", {
                      staticClass: "panel-description",
                      domProps: {
                        innerHTML: _vm._s(_vm.component.description),
                      },
                    })
                  : _vm._e(),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "panel-body" },
            _vm._l(_vm.component.components, function (children, index) {
              return _c(`${children.type}-field`, {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.$checkConditionalViewAllow(
                      children,
                      _vm.components,
                      _vm.variables,
                      _vm.json
                    ),
                    expression:
                      "!$checkConditionalViewAllow(children, components, variables, json)",
                  },
                ],
                key: children.key,
                tag: "component",
                attrs: { component: children, index: index },
              })
            }),
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }